const formats = [
  {
    icon: 'ri-settings-4-line',
    title: 'Разработка системы кадрового резерва',
    desc: 'Для компаний, которые начинают создавать систему с нуля.',
  },
  {
    icon: 'ri-radar-line',
    title: 'Оценка потенциальных резервистов',
    desc: 'Определение сильных сторон, зон развития и готовности к будущим ролям.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Разработка ИПР',
    desc: 'Создание индивидуальных планов развития резервистов.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Программа развития будущих руководителей',
    desc: 'Комплексное обучение и практика для сотрудников кадрового резерва.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Наставничество',
    desc: 'Подключение наставников к развитию резервистов.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Комплексная программа',
    desc: 'Оценка → ИПР → обучение → практика → наставничество → повторная оценка.',
  },
];

export default function WorkFormats() {
  return (
    <section id="formats" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Форматы работы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Как можно организовать работу с кадровым резервом
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {formats.map((f, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${f.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{f.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}